export default function GetDocumentElementById(elementId: string): HTMLElement | null | undefined {
	return process.env.NODE_ENV == "development"
		? window.document.getElementById(elementId)
		: window.document.getElementById("ap-productfinder")?.shadowRoot?.getElementById(elementId);
}
